import type { LandingDict } from './en';

const zhTW: LandingDict = {
  nav: { chat: 'Chat Apps', agentic: 'Agentic Apps', build: "建立 App", org: "My Org", pricing: '價格', privacy: "隱私", contact: "聯絡我們", language: '語言' },
  hero: {
    titlePre: '你的',
    titleMark: '本地 AI',
    titlePost: '\n工作站。',
    sub: "把專業知識、試算表和會議，變成答案、圖表和簡報。資料不離開你的 Mac。",
    watch: "觀看 2 分鐘影片",
    pill: "最新版本",
    chip: "Wi‑Fi 已關閉 · 0 位元組外傳",
    badges: { offline: "可離線使用", server: "你的伺服器，不是我們的", free: "免費開始" },
    reqs: '需要搭載 Apple 晶片的 Mac · 至少 16GB 記憶體 · 32GB 以上可執行更強大的推薦模型',
  },
  stats: {
    free: '免費',
    freeSub: '全部 Chat Apps、模型下載與軟體更新，永久免費',
    chatApps: 'Chat Apps',
    agenticApps: 'Agentic Apps',
    bytesSub: '在本機執行 AI 時，傳送到雲端的資料量',
    langsSub: '種介面語言，繁體中文、English、日本語……',
  },
  film: { kicker: '影片', title: '看看 Estha 如何運作。', watchOnYouTube: '在 YouTube 上觀看', trouble: '無法播放？前往 YouTube 觀看 ↗' },
  overview: {
    kicker: '一個 App，四種用法',
    title: '從對話、到智慧體，\n再到全組織共用的 App。',
    explore: '了解更多',
    chat: { title: 'Chat Apps', desc: '內建專業知識庫的 AI 專家——教科書、方法論、行業領域知識。', tag: '永久免費' },
    agentic: { title: 'Agentic Apps', desc: '端到端處理複雜任務的 AI 智慧體。', tag: '{n} 款，持續增加中' },
    build: { title: "建立 App", desc: '用 Quick Bot 把自己的資料變成 Chat App，或在 Playground 畫布上自由編排流程。', tag: 'Quick Bot · Playground' },
    org: { title: 'My Org', desc: '組織專屬的品牌化 App 空間，App 皆經審核，存取權限一手掌握。', tag: '企業版' },
  },
  chat: {
    kicker: 'Chat Apps',
    title: '有真材實料的 AI 專家。',
    freePill: '永久免費',
    lede: '每個 Chat App 都自帶知識庫，直接在你的 Mac 上建立索引。',
    feats: {
      kb: { title: '本地知識庫', desc: '安裝 App 時即在本機建立知識庫，每個回答都有憑有據。' },
      files: { title: '帶上你自己的檔案', desc: '可附加圖片、PDF、DOCX、TXT 或 MD，長篇文件自動啟用智慧檢索。' },
      browse: { title: '瀏覽、釘選、收藏', desc: '從測評到職涯，分類一目了然；新 App 標上 NEW；⌘K 搜尋一切。' },
    },
  },
  agentic: {
    kicker: 'Agentic Apps',
    title: '{n} 款 Agentic Apps，\n還在持續增加。',
    lede: '從一份試算表、一個 PDF、一段錄音或一個想法，到完成的圖表、簡報、文件或原型——全在你的 Mac 上私密完成。',
    seeThem: '看看它們實際運作',
  },
  build: {
    kicker: '建立 App',
    title: '在你的 Mac 上，\n打造專屬的 Chat App。',
    lede: '把你自己的檔案變成 Chat App——在本機建立索引，準備好了再發佈。',
    quick: {
      badge: '推薦',
      desc: '上傳知識庫並撰寫系統提示，接著發佈。非常適合快速將資料變成問答機器人。',
      items: ['單頁表單，幾個步驟即完成', '開箱即用的知識庫問答', '內建提示範本提供靈感'],
    },
    advanced: {
      title: '進階開發 · Playground',
      desc: '以視覺化節點編輯器自由組合多個節點、分支、AB test 與關鍵字路由。',
      items: ['節點畫布', '多節點 / 分支 / AB test', '細緻的欄位設定與除錯'],
    },
    guideTitle: '本地 AI 建構嚮導，全程在旁協助。',
    guideText: '告訴它你想讓 App 做什麼，它就會一步步告訴你該拖哪些節點、怎麼串接。建立 App 功能包含在進階版中。',
  },
  private: {
    kicker: '隱私優先',
    title: "資料不上雲。\n工作不被追蹤。",
    lede: "AI 在哪裡執行由你決定。Estha 預設為每個功能自動選擇合適的模型，你也可以隨時在 App 內手動切換。",
    boundary: "資料邊界 = 你的網路",
    local: { title: '在這台 Mac 上', desc: '完全離線、資料不離開本機。用這台電腦的記憶體執行模型。', best: '適合：記憶體充足的 Mac' },
    server: { title: '在我的 Estha Server 上', desc: '把繁重的運算交給區域網路裡更強的那台 Mac，讓本機保持輕快。', best: '適合：輕薄筆電、記憶體有限的 Mac' },
    cluster: { desc: '連線到 Mac Studio 叢集，在資料留在內網的前提下，分擔高負載推理。', best: '自動探索區域網路內的 Estha Studio Master 節點' },
    models: {
      every: '所有支援的 Mac 都能執行',
      whisper: "Whisper 語音轉錄",
      recommended: '推薦模型',
      larger: "更大的 Qwen 與 Gemma 模型",
      vision: "支援影像理解的視覺模型",
      open: '開源模型，為 Apple 晶片最佳化',
      openItems: ['在 App 內下載、切換模型', '專用程式碼與嵌入模型', '模型下載永久免費'],
    },
  },
  org: {
    kicker: 'My Org',
    title: '組織專屬的 AI App 空間。',
    lede: 'Estha 中一個帶有你們品牌的專屬區塊，收錄組織為成員審核過的 App。',
    signIn: '登入 My Org Admin',
    talk: '聯絡 Estha 團隊',
    feats: {
      review: { title: '發佈前審核', desc: '每一次新增、更新或下架都須經管理員審核；退回時一定附上書面意見。' },
      access: { title: '依群組或個人授權', desc: '精確決定每個 App 誰能看到——依部門、團隊或個人。' },
      brand: { title: '你的品牌，進駐 App', desc: '組織名稱、歡迎訊息、Logo、橫幅與主題色，上線前即可預覽。' },
    },
  },
  pricing: {
    kicker: '會員',
    title: '免費開始，\n需要時再解鎖全部。',
    free: { name: '免費版', sub: '永久免費。', items: ["全部 Chat Apps", '文件處理，永久免費', '模型下載、軟體和更新——永久免費'] },
    premium: {
      name: '進階版', flag: '14 天免費試用', firstYear: '首年',
      sub: '之後每年 $30。驗證電子郵件後，即可先免費試用 14 天。',
      items: ['包含免費版全部權限', '解鎖全部目前及未來 Agentic Apps', 'Chatbot 建構器——在本機建立、編輯、預覽、儲存並發佈 chatbot'],
      cta: '在 App 內開始試用',
    },
    enterprise: {
      name: '企業版', price: '與我們聯絡', sub: '適合在團隊中導入 Estha 的組織。',
      items: ['包含進階版全部權限', '為團隊量身打造專屬 Chat Apps 與 Agentic Apps', 'Estha Server 應用能力', 'My Org App 空間與 My Org Admin'],
    },
  },
  faq: {
    title: '下載之前，\n你可能想知道。',
    spec: { chip: '晶片', memory: '記憶體', memMin: '至少 16GB', memRec: '32GB 以上可執行推薦模型', languages: '語言', langsVal: '13 種介面語言', version: '最新版本' },
    qa: [
      { q: '會有資料離開我的 Mac 嗎？', a: '選擇「在這台 Mac 上」執行時完全離線，資料不會離開這台電腦。若選擇 Estha Server 或 Mac Studio 叢集，資料只會傳送到你自己區域網路內的那台機器。' },
      { q: "哪些操作需要連網？", a: "只有少數幾項：進階版試用時的登入與電子郵件驗證、下載模型、檢查更新。你的提示詞、檔案和結果永遠不會被上傳——模型下載完成後，AI 功能可完全離線使用。" },
      { q: '哪些免費？哪些需要進階版？', a: '全部 Chat Apps、文件處理、模型下載與更新都免費。進階版可解鎖全部目前及未來的 Agentic Apps 與 Chat App 建構器，並可先免費試用 14 天。' },
      { q: '使用哪些 AI 模型？', a: 'Qwen、Gemma 等領先的開源模型，以及用於語音轉錄的 Whisper，皆透過 Apple 的 MLX 引擎執行。模型可在 App 內下載與切換。' },
      { q: '我可以自己做 App 嗎？', a: '可以。用 Quick Bot 幾個步驟就能把最多 3 個檔案變成附知識庫的 Chat App；也可以用 Playground 節點畫布製作分支、AB test 與測驗。本地建構嚮導會一路協助你。' },
      { q: '組織要如何導入？', a: '採用企業版後，管理員可在 My Org Admin 管理使用者與群組，並在發佈前審核每個 App；成員則會在 Estha 中看到品牌化的 My Org 空間。請聯絡 {email}。' },
    ],
  },
  final: { title: '準備好在本地執行 AI 了嗎？', reqs: '支援所有搭載 Apple 晶片的 Mac · 至少 16GB 記憶體' },
  footer: {
    tagline: '你的本地 AI 工作站——本地執行、MLX 引擎驅動、隱私優先。',
    product: '產品', createApp: '建立 App', pricing: '價格',
    orgs: "My Org", signIn: '登入 My Org Admin',
    security: "安全性", changelog: "更新紀錄", docs: "文件", support: "支援",
    company: '公司', privacy: '隱私權政策', terms: '服務條款',
    rights: '© 2026 Estha. 保留一切權利。',
  },
  proof: { press: "媒體報導", voices: "團隊怎麼說" },
  contact: {
    title: "寄信給 Estha 團隊", copy: "拷貝電子郵件地址", copied: "已拷貝",
    gmail: "用 Gmail 寫信", mailApp: "用「郵件」App 開啟",
    subject: "Estha for Mac 諮詢",
  },
  share: {
    button: "分享", title: "分享 Estha",
    sub: "選一張卡片分享出去，或直接傳連結。",
    style: "卡片", size: "尺寸",
    templates: { hero: "Estha", agentic: "Agentic Apps", private: "隱私" },
    landscape: "橫式", portrait: "直式",
    shareImage: "分享圖片…", download: "下載圖片", copyImage: "拷貝圖片", copied: "已拷貝",
    copyLink: "拷貝連結", link: "連結", postTo: "分享到",
    email: "電子郵件",
    text: "Estha 讓開源 AI 模型完整在你的 Mac 上執行——私密、可離線、免費下載。",
    cardCta: "免費下載 · 適用於搭載 Apple 晶片的 Mac",
    close: "關閉",
  },
  apps: {
    dataAnalyst: { name: '資料分析', description: '上傳 CSV/Excel 檔案，用自然語言提問。自動生成圖表、統計分析和資料洞察 — 所有處理均在本地 Mac 上完成。', tags: ['CSV / Excel', '自動圖表', '自然語言查詢', 'EN / 中文'] },
    pptMaker: { name: 'PPT 製作', description: '描述你的演示主題，即可獲得專業結構的 PowerPoint 簡報。多步驟 AI 流水線自動生成大綱、逐頁內容和精美的 .pptx 檔案。', tags: ['.pptx 輸出', '自動排版', '多步驟流水線'] },
    pdfReader: { name: 'PDF 閱讀助手', description: '開啟 PDF 即可對話提問。每個回答都基於文件原文，附可點擊引用，一鍵跳轉到出處段落 —— 全程在你的 Mac 本地處理。', tags: ['PDF 問答', '可驗證引用', '劃詞提問', '100% 本地'] },
    documentProcessing: { name: '文件處理', description: '你的全能文件專家。從零撰寫部落格、社交媒體文案、法律條款和商務文件。編輯和最佳化現有檔案，跨語言翻譯，審查內容質量 — 完全在 Mac 本地私密執行。', tags: ['撰寫起草', '編輯最佳化', '翻譯', '審閱審計'] },
    meetingIntelligence: { name: '會議智慧', description: '用 AI 錄製、轉錄和分析會議。自動生成會議紀要、行動項和關鍵決策 — 完全私密，音訊絕不離開你的裝置。', tags: ['語音轉錄', '會議紀要', '行動項', '100% 私密'] },
    vibeCoding: { name: 'Vibe Coding：原型', description: '用 AI 生成可互動的介面預覽。用自然語言描述介面，取得可點擊的原型，並持續迭代。最終輸出單一自包含的 .html 檔案，全程在你的 Mac 本機生成。', tags: ['單一 .html 檔案', '可互動預覽', '點選編輯', '100% 本地'] },
    translate: { name: "翻譯", description: "翻譯文字以及 Word、純文字或 Markdown 文件，共用一個術語庫確保用詞一致 —— 全程在你的 Mac 本機處理。", tags: ["文字與文件", ".docx / .txt / .md", "術語庫", "100% 本機"] },
  },
  screens: {
    chat: [
      { label: '瀏覽商店', caption: '瀏覽、安裝、釘選——永久免費' },
      { label: '安裝', caption: '安裝時即在本機建立知識庫' },
      { label: '提問', caption: '依據知識庫作答' },
    ],
    build: [
      { label: '建立 App', caption: 'Quick Bot 或進階開發，都能直接對話' },
      { label: 'Quick Bot', caption: '上傳知識庫、撰寫提示、發佈' },
      { label: 'Playground', caption: '節點、分支與知識，視覺化編排' },
      { label: '已發佈', caption: '已發佈，隨時可以對話' },
    ],
    analyst: [
      { label: '提出問題', caption: '用自然語言詢問你的資料' },
      { label: '分析中', caption: '在你的 Mac 上分析' },
      { label: '圖表與洞察', caption: '答案、圖表與分析過程' },
    ],
    ppt: [
      { label: '設定', caption: '主題、頁數、語言、語氣、風格' },
      { label: '檢視大綱', caption: '生成前先檢視、修改大綱' },
      { label: '預覽簡報', caption: '完成且可編輯的 .pptx，在你的 Mac 上生成' },
    ],
    pdf: [
      { label: '開啟 PDF', caption: '論文、報告、手冊與掃描文件' },
      { label: '閱讀中', caption: '在本機逐頁閱讀' },
      { label: '附出處的回答', caption: '每個回答都指向確切條文' },
    ],
    doc: [
      { label: '選取段落', caption: '選取文字，說出你的需求' },
      { label: '改寫中', caption: '直接在文件中改寫' },
      { label: '接受或拒絕', caption: '改寫、潤飾、翻譯，逐一接受或拒絕' },
    ],
    meeting: [
      { label: '錄音', caption: '在這台 Mac 上即時轉錄' },
      { label: '選擇輸出', caption: '選擇要生成的內容' },
      { label: '摘要', caption: '決策與行動項，自動整理好' },
      { label: '行動項', caption: '負責人與期限，附原文依據' },
    ],
    vibe: [
      { label: '描述需求', caption: '用自然語言描述介面' },
      { label: '生成中', caption: '全程在這台 Mac 上生成' },
      { label: '原型', caption: '可點擊、有版本紀錄，單一 .html 檔案' },
      { label: '點選編輯', caption: '選取任何區塊，說出要改什麼' },
    ],
    translate: [
      { label: "翻譯文字", caption: "紫色詞語來自你的術語庫" },
      { label: "翻譯文件", caption: ".docx、.txt 或 .md —— 原始檔保持不變" },
      { label: "術語庫", caption: "術語庫讓每個用詞都保持一致" },
    ],
    private: [
      { label: '在這台 Mac 上', caption: '完全離線，資料不離開本機。' },
      { label: 'Mac Studio Cluster', caption: '更大的模型，留在內網' },
    ],
    org: [
      { label: '組織 App 空間', caption: '品牌化空間，為團隊打造的 App' },
      { label: '企業版方案', caption: '成員只能開啟你授權的 App' },
    ],
  },
};

export default zhTW;
